import { ChangeDetectorRef, Injectable, OnDestroy } from '@angular/core';
import { autorun } from 'rdataflow/calc';
import { State } from 'rdataflow/core';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';

/**
 * @deprecated Use `HookDirective` instead
 */
@Injectable()
export class ChangeService implements OnDestroy {
  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  private readonly destroy = new Subject();

  listen<T>(observable: Observable<T>, fn?: (value: T) => void): void {
    observable
      .pipe(
        tap(() => this.changeDetectorRef.markForCheck()),
        catchError(e => {
          console.error(e); // eslint-disable-line no-console
          return EMPTY;
        }),
        takeUntil(this.destroy),
      )
      .subscribe(fn);
  }

  listenState<T>(state: State<T>, fn?: (value: T) => void) {
    const run = autorun(() => {
      const value = state.value;
      if (fn) {
        fn(value);
      }
      this.changeDetectorRef.markForCheck();
    });
    this.destroy.subscribe(() => run.dispose());
  }

  ngOnDestroy() {
    this.destroy.next(undefined);
  }
}
